import { Feature } from '@client/graphql/types/graphql.ts';
import { useTranslate } from '@tolgee/react';
import ToggleInput from '@packages/ui/form/input/toggle-input.tsx';
import { useEffect, useState } from 'react';

export default function FeatureEnable(props: {
  feature: Feature;
  enabled: boolean;
  handleChange: (value: boolean, feature: Feature) => void;
}) {
  const { t } = useTranslate();

  const [enabled, setEnabled] = useState<boolean | null>(null);

  useEffect(() => {
    setEnabled(props.enabled);
  }, [props.enabled, setEnabled]);

  if (enabled == null) {
    return null;
  }

  return (
    <div>
      {/*Content*/}
      <div className="p-4 flex justify-between bg-gray-100 mx-4 rounded-lg">
        <div>
          <p>{t(`feature-enable.header.capacity`)}</p>
        </div>
        <div className="flex items-center gap-x-1">
          <ToggleInput
            value={enabled}
            onChange={(value) => {
              props.handleChange(value, props.feature);
            }}
          />
        </div>
      </div>
    </div>
  );
}
